import { render, staticRenderFns } from "./TwoFactorAuthenticationPopup.vue?vue&type=template&id=a9dde5b0&"
import script from "./TwoFactorAuthenticationPopup.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports